import { render, staticRenderFns } from "./ChatMomentMsg.vue?vue&type=template&id=751af746&"
import script from "./ChatMomentMsg.vue?vue&type=script&lang=js&"
export * from "./ChatMomentMsg.vue?vue&type=script&lang=js&"
import style0 from "./ChatMomentMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports